'use strict'

var subtokenize = require('./util/subtokenize.js')

function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }

  return events
}

module.exports = postprocess



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/postprocess.js
// module id = 1520
// module chunks = 0